import { Box, DialogContent, DialogTitle } from "@mui/material";
import { customerContactBusiness } from "api/bussiness/customer/customer-contact-bussiness";
import { AddContact as AddContactModel } from "api/models/request/customer/customer-contact";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect } from "react";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { contactFormSchema } from "./schema";

export const AddContact = observer(() => {
  const {
    customerManagement: {
      contactManagement: { openNew, setProp },
      getCustomerDetail,
      customerDetail,
    },
    catalogueStore: {
      getDepartmentTypes,
      departmentTypes,
      cataloguesToOptionItems,
      defaultOptionItem,
    },
  } = useStores();
  const {
    form: { controls, isValid },
    getControl,
    submitHandler,
  } = useForm<AddContactModel>(contactFormSchema(), {
    departmentTypeId: "",
    email: "",
    fullName: "",
    phoneNumber: "",
    customerId: customerDetail?.id || "",
  });

  useEffect(() => {
    getDepartmentTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (departmentTypes) {
      const options = cataloguesToOptionItems(departmentTypes);
      const defaultCustomerTypeSelected = defaultOptionItem(departmentTypes);
      const control = getControl("departmentTypeId");
      control.setProp("optionItems", options);
      if (defaultCustomerTypeSelected.value) {
        control.setDefaultValue(defaultCustomerTypeSelected?.value);
      }
    }
  }, [cataloguesToOptionItems, defaultOptionItem, departmentTypes, getControl]);

  const saveHandler = useCallback(
    async (data: AddContactModel) => {
      try {
        await customerContactBusiness.add(data);
        if (customerDetail?.id) {
          await getCustomerDetail(customerDetail?.id);
        }

        setProp("openNew", false);
      } catch (ex) {
        console.error(ex);
      }
    },
    [customerDetail?.id, getCustomerDetail, setProp]
  );
  return (
    <DialogForm
      open={openNew}
      onClose={() => setProp("openNew", false)}
      onCancelBtnClicked={() => setProp("openNew", false)}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Thêm mới liên hệ</DialogTitle>
      <DialogContent>
        <Box sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
        </Box>
      </DialogContent>
    </DialogForm>
  );
});
